import { Link } from "react-router-dom";
import { Activity, Zap, Stethoscope, Dumbbell, Thermometer, Gauge, ArrowRight } from "lucide-react";
import { usePulse } from "@/components/HeroPulse";

function Chip({ icon: Icon, label, value, accent }) {
  return (
    <span className="shrink-0 inline-flex items-center gap-1.5 font-cond uppercase tracking-wider text-[10px] text-white/55">
      <Icon size={11} className={accent || "text-titans-blue"} />
      {label}
      <b className="font-display text-sm text-white leading-none tabular-nums">{value}</b>
    </span>
  );
}

/** Compact horizontal Titan Pulse strip for article pages. */
export default function TitanPulseStrip() {
  const pulse = usePulse();
  if (!pulse) return null;
  const wx = pulse.weather;
  const show = (k) => !pulse.rows || pulse.rows[k] !== false;
  return (
    <div
      className="border-y border-white/[0.08]"
      style={{ background: "rgba(7,18,33,0.97)" }}
      data-testid="titan-pulse-strip"
    >
      <div className="max-w-[1300px] mx-auto px-5 md:px-10 py-2.5 flex items-center gap-5 overflow-x-auto no-scrollbar">
        <Link to="/" className="shrink-0 inline-flex items-center gap-1.5 group" data-testid="pulse-strip-brand">
          <Activity size={13} className="text-titans-red" />
          <span className="font-display uppercase text-sm text-white leading-none group-hover:text-titans-blue transition-colors">Titan Pulse</span>
          <span className="live-dot" style={{ transform: "scale(0.6)" }} />
        </Link>
        <Chip icon={Zap} label="Updates" value={pulse.updates_today} accent="text-titans-red" />
        {show("injuries") && <Chip icon={Stethoscope} label="Injuries" value={pulse.injuries_week} />}
        {show("practice") && pulse.practice_status && <Chip icon={Dumbbell} label="Practice" value={pulse.practice_status} />}
        {show("weather") && wx?.temp_f != null && <Chip icon={Thermometer} label="Nashville" value={`${wx.temp_f}°`} />}
        {show("confidence") && typeof pulse.confidence === "number" && <Chip icon={Gauge} label="Confidence" value={`${pulse.confidence}%`} />}
        <Link
          to="/"
          className="ml-auto shrink-0 inline-flex items-center gap-1 font-cond uppercase tracking-wider text-[10px] text-titans-blue hover:text-white transition-colors"
          data-testid="pulse-strip-full"
        >
          Full Pulse <ArrowRight size={10} />
        </Link>
      </div>
    </div>
  );
}
